import extend from "../../services/extend";

/**
 * @ngdoc directive
 * @name ng.directive:vRoll
 * @param vue
 */

export default (vue) => extend(vue, (vue) => {
    return {
        name: 'modules.display.' + vue.exp,
        touchHandler: ('ontouchstart' in document.documentElement ? "touchstart" : "click"),
        init() {
            // Set element data-roll="name"
            vue.el.dataset.roll = vue.exp;

            if ( this.touchHandler === 'click') {
                vue.el.addEventListener('mouseenter', () => {
                    this.enter(() => {
                        Object.keys(vue.get('modules.display')).forEach((index) => {
                            vue.set('modules.display.' + index, index === vue.exp);
                        });
                    });
                    if ( vue.get('modules.hover')) {
                        vue.el.addEventListener('mouseleave', () => {
                            this.leave();
                        }, { ive: true });
                    }
                }, { ive: true });
            }

            // run reactive effect
            vue.effect(() => {
                if ( vue.get(this.name)) {
                    vue.el.classList.remove("v-hide");
                } else {
                    vue.el.classList.add("v-hide");
                }
            });
        },
        // Show on mouse over
        enter ( callback ) {
            clearTimeout(vue.get('modules.timeout'));
            vue.set('modules.timeout', setTimeout(() => {
                if ( typeof callback !== "undefined") {
                    callback();
                }

            }, 150, this ));
        },

        // Hide on mouse leave
        leave () {
            clearTimeout(vue.get('modules.timeout'));
            vue.set('modules.timeout', setTimeout(() => {
                Object.keys(vue.get('modules.display')).forEach((index) => {
                    vue.set('modules.display.' + index, false);
                });
                vue.el.classList.add("v-hide");
            }, 150, this ));
        }
    }
});